import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#4A331D] text-white py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <div className="mb-4 bg-white p-3 rounded-lg inline-block">
              <Logo size="small" />
            </div>
            <p className="text-sm text-gray-300">BEKAJ BAU Malerbetrieb</p>
            <p className="text-gray-200 mb-4 mt-2">
              Ihr zuverlässiger Partner für Bau- und Modernisierungsarbeiten in Großkrotzenburg und Umgebung.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4 text-[#D4AA6A]">Kontakt</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-[#D4AA6A]" />
                <a href="/anruf" data-track="footer_phone" className="hover:text-[#D4AA6A] transition-colors">
                  0176 20283482
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-[#D4AA6A]" />
                <a href="mailto:kontakt@bekajbau.de" data-track="email_click" data-track-value="footer" className="hover:text-[#D4AA6A] transition-colors">
                  kontakt@bekajbau.de
                </a>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="w-5 h-5 mt-1 text-[#D4AA6A]" />
                <span data-track="location_view" data-track-value="footer-address">
                  BEKAJ BAU<br />
                  Elson Bekaj<br />
                  Mainstr. 6<br />
                  63538 Großkrotzenburg
                </span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4 text-[#D4AA6A]">Rechtliches</h3>
            <div className="space-y-2">
              <Link to="/impressum" data-track="footer_link" data-track-value="impressum" className="block hover:text-[#D4AA6A] transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" data-track="footer_link" data-track-value="datenschutz" className="block hover:text-[#D4AA6A] transition-colors">
                Datenschutz
              </Link>
              <button
                type="button"
                onClick={() => {
                  localStorage.removeItem('bekaj-cookie-consent');
                  window.location.reload();
                }}
                className="block text-left hover:text-[#D4AA6A] transition-colors"
                data-testid="cookie-settings-reopen"
              >
                Cookie-Einstellungen
              </button>
            </div>
          </div>
        </div>
        
        <div className="border-t border-[#725029] mt-8 pt-8 text-center">
          <p className="text-gray-200 text-sm">
            © {currentYear} BEKAJ BAU. Alle Rechte vorbehalten.
          </p>
          <p className="text-gray-300 text-sm mt-2">
            Webseite erstellt von{" "}
            <a 
              href="https://www.bamediaperformance.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#D4AA6A] hover:text-[#D4AA6A]/80 transition-colors underline"
            >
              BA Media Performance
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;